import React from 'react';

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    aboutUsCallToAction = () => {
        if (this.props.aboutDetails && this.props.aboutDetails.aboutUsCtaType && this.props.aboutDetails.aboutUsCta) {
            let aboutDetails = this.props.aboutDetails;
            if (aboutDetails.aboutUsCtaType === 'url') {
                return (
                    <a className='btn btn__borderd' href={aboutDetails.aboutUsCta} target='_blank'>
                        {aboutDetails.aboutUsCtaName}
                    </a>
                )
            } else if (aboutDetails.aboutUsCtaType === 'phone') {
                return (
                    <a className='btn btn__borderd' href={"tel:" + aboutDetails.aboutUsCta} target='_blank'>
                        {aboutDetails.aboutUsCtaName}
                    </a>
                )
            }
        }
    }


    render() {
        return (
            <>
                <section className="top__section wrap-top" id="about">
                    <div className='content'>
                        <div className="two-column">

                            <div className="right-column">
                                <div className='vertical-border'>
                                    <h2 className="title" id="aboutHeader"><span>About Us</span></h2>
                                    {this.props.aboutDetails && this.props.aboutDetails.about_us.split('\n').map(i => {
                                        return <p>{i}</p>
                                    })
                                    }
                                </div>
                                {this.aboutUsCallToAction()}
                            </div>
                            <div className="left-column img-column">
                                <div className="wrap-img about-img">
                                    <img src={this.props.aboutDetails && this.props.aboutDetails.image}
                                         alt={this.props.aboutDetails.imageDescription}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </>
        );
    }
}

export default About;